import React from 'react';
import { Box, IconButton } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import { ReactComponent as AutoAppLogo } from '../../../assets/autoApp-logo.svg';
import { homeIconStyles, logoBoxStyles, logoSvgStyles } from '../styles/NavBarStyles';

export const NavBarLogo = ({ onHomeClick }) => {
  return (
    <>
      <IconButton
        size="large"
        edge="start"
        color="inherit"
        aria-label="home"
        onClick={onHomeClick}
        sx={homeIconStyles}
      >
        <HomeIcon />
      </IconButton>

      <Box sx={logoBoxStyles}>
        <AutoAppLogo style={logoSvgStyles} />
      </Box>
    </>
  );
};
